import { makeStyles } from '@material-ui/core'
import { ChevronLeft as ChevronLeftIcon } from '@material-ui/icons'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { useAuth } from 'src/modules/auth'
import { Button, Container } from 'src/modules/ui'
import { useActionRunner } from 'src/modules/notification'

import { mapSectionToNav } from './Suppliers'
import { useSuppliers } from '../hooks'
import SupplierProfile from './SupplierProfile'

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1, 2, 2),
  },
  backButton: {
    color: theme.palette.lightGreen.main,
    marginBottom: theme.spacing(1),
  },
  backLink: {
    textDecoration: 'inherit',
  },
}))

const SingleSupplierView = ({ linkPrefix, match, ...props }) => {
  const { id } = match.params
  const { hasPermission } = useAuth()
  const classes = useStyles()

  const {
    fetchSingleSupplier,
    lastPageWasSupplierList,
    supplier,
    suppliers,
  } = useSuppliers()
  const [doFetchSingleSupplier, fetching] = useActionRunner(
    fetchSingleSupplier,
    {
      initialFetchingState: true,
    }
  )

  useEffect(() => {
    doFetchSingleSupplier(id)
  }, [])

  if (fetching || !supplier.id) {
    return null
  }

  return (
    <Container backLink>
      <Link
        className={classes.backLink}
        to={`${linkPrefix}/suppliers/${mapSectionToNav(suppliers.section)}`}
      >
        <Button
          className={classes.backButton}
          size="large"
          startIcon={<ChevronLeftIcon />}
          variant="text"
        >
          Suppliers
        </Button>
      </Link>
      <SupplierProfile
        canStar={hasPermission('source_suppliers')}
        canAddProducts={hasPermission('add_products')}
        canApproveAgreement={hasPermission('approve_suppliers')}
        canRequestAgreement={hasPermission('source_suppliers')}
        linkPrefix={linkPrefix}
        showBack={lastPageWasSupplierList}
        {...props}
        {...supplier}
      />
    </Container>
  )
}

SingleSupplierView.defaultProps = {
  linkPrefix: '',
}

export default SingleSupplierView
